import arrow from "../../assets/icons/arrow.svg";

export interface EmptyDrawCardProps {
  children: React.ReactNode;
  onClick?: () => void;
}

export default function EmptyDrawCard(props: EmptyDrawCardProps) {
  return (
    <div
      onClick={props.onClick}
      className={`${props.onClick != undefined && "cursor-pointer"} 2xl:w-[250px] xl:w-[235px] lg:w-[210px] md:w-[190px] sm:w-[180px] w-[175px] self-stretch flex justify-center items-center rounded-lg bg-bastille shadow-sm hover:scale-105 duration-250`}
    >
      <span
        className={`flex flex-row items-center ~text-sm/base font-koulen font-bold ~mx-5/6 ~my-3/4 ${props.onClick != undefined ? "bg-gradient-to-b from-mango to-crail bg-clip-text text-transparent" : "text-gray"}`}
      >
        {props.children}
        {props.onClick != undefined && (
          <img src={arrow} className="~pl-1/1.5 ~h-1.5/2" alt="arrow" />
        )}
      </span>
    </div>
  );
}
